import { Icon } from '@iwoca/orion';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';
import messages from './BankStatements.messages';
import { FormattedMessage } from 'react-intl';
import { Text } from '@ui';

const ManualUpload = ({
    toggleLinkBankAccount
}: {
    toggleLinkBankAccount: () => void;
}) => {
    return (
        <DocumentRequirement documentType="bank statement" className="!p-0">
            <ul>
                <li>
                    <FormattedMessage {...messages.firstBullet} />
                </li>
                <li>
                    <FormattedMessage {...messages.secondBullet} />
                </li>
            </ul>

            <div className="mt-l flex items-start">
                <Icon
                    icon="link"
                    className="mr-s mt-xs shrink-0 fill-structure-40"
                />
                <div className="inline-flex flex-wrap">
                    <Text className="text-structure-40">
                        We also offer Open Banking, a secure way to share your
                        business banking data without sharing your password.
                    </Text>
                    <button
                        onClick={toggleLinkBankAccount}
                        className="border-none bg-transparent px-0 font-med text-primary-40 underline hover:cursor-pointer"
                    >
                        Link my bank account
                    </button>
                </div>
            </div>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default ManualUpload;
